import axiosInstance from "../axios_instance";

export async function createServiceTicket(body) {
  try {
    return await axiosInstance.post(`myservices/create-ticket`, body);
  } catch (error) {
    return error;
  }
}

export async function createUserServiceChat(body) {
  try {
    return await axiosInstance.post(`myservices/chat-create`, body);
  } catch (error) {
    return error;
  }
}

export async function getUserServiceTickets(body) {
  try {
    return await axiosInstance.post(`myservices/get-tickets`, body);
  } catch (error) {
    return error;
  }
}

export async function updateServiceTicketStatus(body) {
  try {
    return await axiosInstance.put(`myservices/update-ticket-status`, body);
  } catch (error) {
    return error;
  }
}

export async function saveMyServiceNotes(body) {
  try {
    return await axiosInstance.post(`myservices/saveNote`, body);
  } catch (error) {
    return error;
  }
}

export async function getMyServiceNotes(userID, registeredServiceID) {
  try {
    return await axiosInstance.post(`myservices/getNotes`, {
      userID,
      registeredServiceID
    });
  } catch (error) {
    return error;
  }
}

export async function saveMyServiceReminders(body) {
  try {
    return await axiosInstance.post(`myservices/saveReminder`, body);
  } catch (error) {
    return error;
  }
}

export async function getMyServiceReminders(userID, registeredServiceID) {
  try {
    return await axiosInstance.post(`myservices/getReminders`, {
      userID,
      registeredServiceID
    });
  } catch (error) {
    return error;
  }
}
